/* eslint-disable jsx-a11y/href-no-hash */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { List, Modal, Icon, Divider, Popup } from 'semantic-ui-react';

import ModalAdSet from './ModalAdSet';
import ModalAdSetDAA from './ModalAdSetDAA';
import AdSetPopUp from './AdSetPopUp';
import AdSetDAAPopUp from './AdSetDAAPopUp';
import './AdSetList.css';

class AdSetList extends Component {
  constructor(props) {
    super(props);
    this.copyAdset = this.copyAdset.bind(this);
    this.removeAdset = this.removeAdset.bind(this);
    this.openAdsetModal = this.openAdsetModal.bind(this);
  }

  state = {
    showModalAdset: false,
    showModalAdsetDAA: false,
    currentCampaign: null,
    adsetToEdit: null,
    currentCampaignObjective: '',
    campaignName: ''
  };

  onCloseModalAdset = () => {
    this.setState({
      showModalAdset: false,
      showModalAdsetDAA: false,
      currentCampaign: null,
      adsetToEdit: null
    });
  };

  openAdsetModal = (campaignId, adset, objective, campaignName) => () => {
    const showModalDAA = objective === 'PRODUCT_CATALOG_SALES';

    this.setState({
      showModalAdset: !showModalDAA,
      showModalAdsetDAA: showModalDAA,
      currentCampaign: campaignId,
      adsetToEdit: adset,
      currentCampaignObjective: objective,
      campaignName
    });
  };

  addAdset = (adset) => {
    const adSetToPush = adset;
    adSetToPush.campaignId = this.state.currentCampaign;
    this.props.addAdset(adSetToPush);
    this.onCloseModalAdset();
  };

  removeAdset = (id) => () => {
    this.props.removeAdset(id);
  };

  copyAdset = (adset) => () => {
    this.props.copyAdset(adset);
  };

  render() {
    const { campaigns, adsets, audienceOptions } = this.props;
    const {
      showModalAdset,
      adsetToEdit,
      showModalAdsetDAA,
      currentCampaignObjective,
      campaignName,
      currentCampaign
    } = this.state;
    let selectedCampaign;
    let currentCampaignIsHec = false;
    if (currentCampaign) {
      selectedCampaign = campaigns.find(
        (campaign) => campaign.id === currentCampaign
      );
    }
    if (selectedCampaign) {
      currentCampaignIsHec = selectedCampaign.is_hec_campaign;
    }
    return (
      <div>
        {campaigns.map((campaign) => (
          <List.Item className="manage-package-adset-container">
            <b>{`${campaign.name}: ${
              campaign.objective === 'PRODUCT_CATALOG_SALES'
                ? 'DAA'
                : campaign.objective === 'VIDEO_VIEWS'
                ? 'Video Views'
                : campaign.objective
            }`}</b>
            <List.Item className="manage-package-adset-container">
              {adsets
                .filter((item) => item.campaignId === campaign.id)
                .map((adset) => (
                  <div className="adset-item-container">
                    {adset.adSetName}
                    <a
                      role="button"
                      tabIndex={0}
                      className="adset-item-remove-link"
                      onClick={this.removeAdset(adset.id)}
                    >
                      <Icon size="large" name="cancel" />
                    </a>
                    <Divider hidden />
                    <div className="adset-item-container-operations">
                      <a
                        role="button"
                        tabIndex={0}
                        className="adset-item-edit-link"
                        onClick={this.copyAdset(adset)}
                      >
                        <Icon size="large" name="copy outline" />
                      </a>
                      <a
                        role="button"
                        tabIndex={0}
                        className="adset-item-edit-link"
                        onClick={this.openAdsetModal(
                          campaign.id,
                          adset,
                          campaign.objective,
                          campaign.name
                        )}
                      >
                        <Icon size="large" name="edit" />
                      </a>
                      <Popup trigger={<Icon size="large" name="info circle" />}>
                        <Popup.Header>Ad-Set Details</Popup.Header>
                        <Popup.Content>
                          {campaign.objective !== 'PRODUCT_CATALOG_SALES' ? (
                            <AdSetPopUp adset={adset} />
                          ) : (
                            <AdSetDAAPopUp adset={adset} />
                          )}
                        </Popup.Content>
                      </Popup>
                    </div>
                  </div>
                ))}
            </List.Item>
            <div className="manage-package-adset-link">
              <a
                href="#"
                onClick={this.openAdsetModal(
                  campaign.id,
                  null,
                  campaign.objective,
                  campaign.name
                )}
              >
                + Add Adset
              </a>
            </div>
          </List.Item>
        ))}
        <Modal
          dimmer={'inverted'}
          open={showModalAdset}
          onClose={this.onCloseModalAdset}
          size="small"
          className="modal-picker"
        >
          <Modal.Header>Add AdSet</Modal.Header>
          <Modal.Content>
            <ModalAdSet
              objective={currentCampaignObjective}
              onCloseModalAdset={this.onCloseModalAdset}
              addAdset={this.addAdset}
              adsetToEdit={adsetToEdit}
              campaignName={campaignName}
              isHecCampaign={currentCampaignIsHec}
              audienceOptions={audienceOptions}
            />
          </Modal.Content>
        </Modal>
        <Modal
          dimmer={'inverted'}
          open={showModalAdsetDAA}
          onClose={this.onCloseModalAdset}
          size="small"
          className="modal-picker"
        >
          <Modal.Header>Add AdSet</Modal.Header>
          <Modal.Content>
            <ModalAdSetDAA
              onCloseModalAdset={this.onCloseModalAdset}
              addAdset={this.addAdset}
              adsetToEdit={adsetToEdit}
              campaignName={campaignName}
              audienceOptions={audienceOptions}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

export default AdSetList;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdSetList.js